/*
 * @Autor: Nehc
 * @Date: 2020-12-04 14:53:15
 * @LastEditors: Nehc
 * @LastEditTime: 2020-12-04 15:01:12
 */
import Products from './table_form.vue';

export default Products;
